<div class="h-100 w-100 p-5 overflow-hidden">
    <div class="d-flex justify-content-between align-items-center">
        @if (currentChart) {
            <h1 class="text-color-primary">{{currentChart.title}}</h1>
            <div>
                <mat-form-field class="pe-auto me-2">
                    <mat-label>Select Metric Type</mat-label>
                    <mat-select [value]="currentChart" (selectionChange)="changeChart($event.value)">
                        @for (graph of data; track graph.graph_id) {
                        <mat-option [value]="graph">{{graph.title}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        }
    </div>
    <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions" class="full-height-chart" />
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</div>
